var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.visible)?_c('div',{staticClass:"alert alert-warning",attrs:{"role":"alert"}},[_vm._v("\n        Sorry, plans' availability may not be accurate at this time due to technical issues.\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }